import LegalPage from "../legal/LegalPage";

const content = {
    ar: {
        title: "الشروط والأحكام",
        lastUpdated: "آخر تحديث: أغسطس 2026",
        sections: [
            {
                heading: "قبول الشروط",
                paragraphs: [
                    "باستخدامك لموقع [سليم الشرعبي] وإتمام أي عملية شراء، فإنك توافق على الالتزام بهذه الشروط والأحكام بالكامل.",
                ],
            },
            {
                heading: "الحسابات",
                paragraphs: [
                    "أنت مسؤول عن الحفاظ على سرية بيانات حسابك وكلمة المرور، وعن جميع الأنشطة التي تتم من خلال حسابك.",
                ],
            },
            {
                heading: "الطلبات والأسعار",
                list: [
                    "جميع الأسعار المعروضة تشمل الضرائب المطبّقة ما لم يُذكر خلاف ذلك",
                    "نحتفظ بالحق في تعديل الأسعار أو توفر المنتجات دون إشعار مسبق",
                    "يُعتبر الطلب مؤكدًا فقط بعد استلام الدفع (أو تأكيد طلبك في حالة الدفع عند الاستلام)",
                    "نحتفظ بالحق في رفض أو إلغاء أي طلب لأسباب تتعلق بتوفر المخزون أو الاشتباه في الاحتيال",
                ],
            },
            {
                heading: "الدفع",
                paragraphs: [
                    "تتم معالجة المدفوعات الإلكترونية عبر بوابة الدفع الآمنة Moyasar. لا نقوم بتخزين بيانات بطاقتك على خوادمنا في أي وقت.",
                ],
            },
            {
                heading: "الشحن والتوصيل",
                paragraphs: [
                    "نسعى لتوصيل الطلبات في أسرع وقت ممكن، لكن أوقات التوصيل المذكورة تقديرية وقد تختلف حسب الموقع والظروف الخارجة عن إرادتنا.",
                ],
            },
            {
                heading: "الملكية الفكرية",
                paragraphs: [
                    "جميع المحتويات الموجودة على الموقع (شعارات، صور، نصوص) هي ملك لـ [اسم المتجر] ولا يجوز نسخها أو استخدامها دون إذن مسبق.",
                ],
            },
            {
                heading: "تعديل الشروط",
                paragraphs: [
                    "نحتفظ بالحق في تعديل هذه الشروط في أي وقت. استمرارك في استخدام الموقع بعد أي تعديل يُعتبر موافقة منك على الشروط الجديدة.",
                ],
            },
        ],
    },
    en: {
        title: "Terms & Conditions",
        lastUpdated: "Last updated: August 2026",
        sections: [
            {
                heading: "Acceptance of Terms",
                paragraphs: [
                    "By using [saleem alsharabi] and completing any purchase, you agree to be fully bound by these Terms & Conditions.",
                ],
            },
            {
                heading: "Accounts",
                paragraphs: [
                    "You are responsible for maintaining the confidentiality of your account credentials and for all activity that occurs under your account.",
                ],
            },
            {
                heading: "Orders & Pricing",
                list: [
                    "All displayed prices include applicable taxes unless stated otherwise",
                    "We reserve the right to modify prices or product availability without prior notice",
                    "An order is considered confirmed only after payment is received (or order confirmation for Cash on Delivery)",
                    "We reserve the right to refuse or cancel any order due to stock availability or suspected fraud",
                ],
            },
            {
                heading: "Payment",
                paragraphs: [
                    "Online payments are processed through the secure Moyasar payment gateway. We never store your card details on our servers.",
                ],
            },
            {
                heading: "Shipping & Delivery",
                paragraphs: [
                    "We aim to deliver orders as quickly as possible, but stated delivery times are estimates and may vary based on location and circumstances beyond our control.",
                ],
            },
            {
                heading: "Intellectual Property",
                paragraphs: [
                    "All content on this site (logos, images, text) is the property of [Store Name] and may not be copied or used without prior permission.",
                ],
            },
            {
                heading: "Changes to Terms",
                paragraphs: [
                    "We reserve the right to modify these terms at any time. Continued use of the site after any change constitutes your acceptance of the new terms.",
                ],
            },
        ],
    },
};

export default function TermsConditions ()
{
    return <LegalPage content={ content } />;
}
